import { Accordion, BorderedAccordionItem } from "components/Accordion";

type PaperDebugInfoProps = {
  debugInfo: any;
};

// Renders a JSON blob of the debug information returned from the paper_search endopint when the &debug flag is set to true
function PaperDebugInfo({ debugInfo }: PaperDebugInfoProps) {
  return (
    <div className="mt-6">
      <Accordion defaultOpen="debug-info">
        {[
          <BorderedAccordionItem
            key="debug-info"
            itemKey="debug-info"
            title="Debug Info"
            content={
              <div className="mt-4 p-4 bg-bg-faint rounded-2xl sm:leading-[150%]">
                <pre className="text-xs whitespace-pre-wrap break-words hyphens-auto">
                  {JSON.stringify(debugInfo, null, 2)}
                </pre>
              </div>
            }
          />,
        ]}
      </Accordion>
    </div>
  );
}

export default PaperDebugInfo;
